import { render, staticRenderFns } from "./ItemHistory.vue?vue&type=template&id=232850c4&scoped=true&"
import script from "./ItemHistory.vue?vue&type=script&lang=js&"
export * from "./ItemHistory.vue?vue&type=script&lang=js&"
import style0 from "./ItemHistory.vue?vue&type=style&index=0&id=232850c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232850c4",
  null
  
)

export default component.exports